import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Terms() {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Button 
          onClick={() => navigate('/')} 
          variant="outlined" 
          sx={{ mb: 2 }}
        >
          Back to Home
        </Button>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Terms of Service
          </Typography>

          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing and using the services provided by Bhaktivedanta Vedic Academy, you agree to be bound by these Terms of Service and all applicable laws and regulations.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. Course Enrollment and Access
          </Typography>
          <Typography variant="body1" paragraph>
            • Course materials are provided for personal, non-commercial use only
            • Access to course content is subject to registration and acceptance
            • We reserve the right to modify or discontinue courses at any time
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Intellectual Property Rights
          </Typography>
          <Typography variant="body1" paragraph>
            All content provided through our services, including but not limited to text, graphics, logos, and video content, is the property of Bhaktivedanta Vedic Academy or its licensors and is protected by copyright and other intellectual property laws.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. User Conduct
          </Typography>
          <Typography variant="body1" paragraph>
            Users agree to:
            • Provide accurate registration information
            • Maintain the security of their account
            • Not share access credentials
            • Engage respectfully with other users and instructors
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Disclaimer of Warranties
          </Typography>
          <Typography variant="body1" paragraph>
            Our services are provided "as is" without any warranties, expressed or implied. We do not guarantee that our services will be uninterrupted or error-free.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            Bhaktivedanta Vedic Academy shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            7. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these terms at any time. Continued use of our services after such modifications constitutes acceptance of the updated terms.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            8. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For questions about these Terms of Service, please contact:
            Bhaktivedanta Vedic Academy
            4530 Oak Shores Dr
            Plano, TX 75024-7350
            Federal EIN: 47-1025266
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Terms; 